//Authenticate
export const apiGetAssociationNameList = `Association/GetAssociationNameList`
export const apiGetAssociationChildList = `Association/GetAssociationChildList`
export const apiUpdateAssociation = `Association/UpdateAssociation`
export const apiDeleteAssociation = `Association/DeleteAssociation`
export const apiCreateAssociation = `Association/CreateAssociation`
export const apiGetAssociationDetail = `Association/GetAssociationDetail`
export const apiGetRequestApproval = `Association/GetRequestApproval`
export const apiApproveRequest = `Association/ApproveRequest`
export const apiRejectRequest = `Association/RejectRequest`
export const apiGetMyAssociationList = `Association/GetMyAssociationList`
export const apiCreateAssociationAdmin = `Association/CreateAssociationAdmin`
export const apiGetAssociationListNoAuthor = `Association/GetAssociationListNoAuthor`

export const apiGetListMemberByAssociation = `Association/GetListMemberByAssociation`
